import { useReveal } from "@/hooks/useReveal";
import { SiteHeader } from "@/components/landing/SiteHeader";
import { Hero } from "@/components/landing/Hero";
import { SoundFamiliar } from "@/components/landing/SoundFamiliar";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Services } from "@/components/landing/Services";
import { Licence } from "@/components/landing/Licence";
import { FirstThirtyDays } from "@/components/landing/FirstThirtyDays";
import { Officer } from "@/components/landing/Officer";
import { Academy } from "@/components/landing/Academy";
import { Faq } from "@/components/landing/Faq";
import { CtaBand } from "@/components/landing/CtaBand";
import { SiteFooter } from "@/components/landing/SiteFooter";

export default function App() {
  useReveal();
  return (
    <>
      <a className="skip-link" href="#main" data-testid="skip-link">Skip to content</a>
      <SiteHeader />
      <main id="main">
        <Hero />
        <SoundFamiliar />
        <HowItWorks />
        <Services />
        <Licence />
        <FirstThirtyDays />
        <Officer />
        <Academy />
        <Faq />
        <CtaBand />
      </main>
      <SiteFooter />
    </>
  );
}
